import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { eliteIncludes, eliteRows } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
export function EliteComparison() {
  return <section className="border-y border-line bg-surface px-4 py-12 md:py-16" data-id="element-43" data-mp="atq2gr0er4sj">
      <div className="mx-auto max-w-5xl" data-id="element-44" data-mp="5v52msp2in4m">
        <Eyebrow data-id="element-45" data-mp="jwhhf0shsiox">⭐ La opción para grupos competitivos</Eyebrow>
        <SectionTitle data-id="element-46" data-mp="juo9li657sfc">
          ¿Qué agrega <span className="text-gold" data-id="element-47" data-mp="exeb7d0s06fd">Rítmica Élite?</span>
        </SectionTitle>
        <div className="mt-10 grid gap-4 md:grid-cols-2 md:gap-6" data-id="element-48" data-mp="evbl6szmidan">
          <div className="rounded-2xl border border-line bg-ink p-6" data-id="element-49" data-mp="tkzgndl4ihqg">
            <h3 className="mb-5 flex items-center gap-2 font-bold text-white" data-id="element-50" data-mp="omxv8m0866bt">
              <XIcon aria-hidden="true" className="rounded-lg bg-red-500/15 p-2 text-red-400" size={40} data-id="element-51" data-mp="12mph18wzgr0d" />
              Sin Rítmica Élite
            </h3>
            <ul className="space-y-3" data-id="element-52" data-mp="2waqpj3rtnmfe">
              {eliteRows.map(([without]) => <li key={without} className="flex gap-2 text-sm font-medium text-zinc-300" data-id="element-53" data-mp="30bk8diqeqb1f">
                  <XIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-red-400" data-id="element-54" data-mp="35b6n5wlvvzcc" />
                  {without}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-gold bg-ink p-6" data-id="element-55" data-mp="3f92xim6zyq9e">
            <h3 className="mb-5 flex items-center gap-2 font-bold text-white" data-id="element-56" data-mp="3f8ulewip7oz9">
              <CheckIcon aria-hidden="true" className="rounded-lg bg-gold/15 p-2 text-gold" size={40} data-id="element-57" data-mp="3j9dc2n8uuozv" />
              Con Rítmica Élite
            </h3>
            <ul className="space-y-3" data-id="element-58" data-mp="3szpv2b10ua3w">
              {eliteRows.map(([, withElite]) => <li key={withElite} className="flex gap-2 text-sm font-bold text-white" data-id="element-59" data-mp="1vrilaw9yhyl">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-60" data-mp="6u2r9iau2mf8" />
                  {withElite}
                </li>)}
            </ul>
          </div>
        </div>
        <div className="mt-8 rounded-2xl border border-gold/25 bg-ink p-6 text-center" data-id="element-61" data-mp="38d01r8wsr6a3">
          <p className="text-sm font-extrabold uppercase tracking-[.14em] text-gold" data-id="element-62" data-mp="3n14ocnyz01y5">
            Rítmica Élite incluye
          </p>
          <div className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-63" data-mp="3i7josrhqazwu">
            {eliteIncludes.map(item => <span key={item} className="rounded-full border border-line bg-surface px-3 py-1.5 text-xs font-bold text-zinc-200" data-id="element-64" data-mp="3r1y9j9l132nc">
                {item}
              </span>)}
          </div>
          <div className="mt-7" data-id="element-65" data-mp="4w1demmbovpt">
            <Button href="#pricing" className="w-full text-xs md:w-auto md:text-sm" data-id="element-66" data-mp="4svnx69s7rtk">
              Quiero el pack completo + Rítmica Élite →
            </Button>
          </div>
        </div>
      </div>
    </section>;
}